import { createAvroEventsHub as b } from "@zapier/avro-events";
import { emit as m } from "@zapier/events-toolkit-browser";
import { UserInteractionEvent as h } from "./observability/tracking/trackingTypes.es.js";
import { FullStoryAPI as d } from "@zapier/react-fullstory";
var l = function() {
  return l = Object.assign || function(o) {
    for (var e, n = 1, a = arguments.length; n < a; n++) {
      e = arguments[n];
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (o[t] = e[t]);
    }
    return o;
  }, l.apply(this, arguments);
};
function j(i, o) {
  var e = {};
  for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && o.indexOf(n) < 0 && (e[n] = i[n]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(i); a < n.length; a++)
      o.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(i, n[a]) && (e[n[a]] = i[n[a]]);
  return e;
}
function _(i, o, e, n) {
  function a(t) {
    return t instanceof e ? t : new e(function(u) {
      u(t);
    });
  }
  return new (e || (e = Promise))(function(t, u) {
    function f(c) {
      try {
        r(n.next(c));
      } catch (y) {
        u(y);
      }
    }
    function s(c) {
      try {
        r(n.throw(c));
      } catch (y) {
        u(y);
      }
    }
    function r(c) {
      c.done ? t(c.value) : a(c.value).then(f, s);
    }
    r((n = n.apply(i, o || [])).next());
  });
}
function w(i, o) {
  var e = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, n, a, t, u = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return u.next = f(0), u.throw = f(1), u.return = f(2), typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function f(r) {
    return function(c) {
      return s([r, c]);
    };
  }
  function s(r) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; u && (u = 0, r[0] && (e = 0)), e; ) try {
      if (n = 1, a && (t = r[0] & 2 ? a.return : r[0] ? a.throw || ((t = a.return) && t.call(a), 0) : a.next) && !(t = t.call(a, r[1])).done) return t;
      switch (a = 0, t && (r = [r[0] & 2, t.value]), r[0]) {
        case 0:
        case 1:
          t = r;
          break;
        case 4:
          return e.label++, { value: r[1], done: !1 };
        case 5:
          e.label++, a = r[1], r = [0];
          continue;
        case 7:
          r = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (t = e.trys, !(t = t.length > 0 && t[t.length - 1]) && (r[0] === 6 || r[0] === 2)) {
            e = 0;
            continue;
          }
          if (r[0] === 3 && (!t || r[1] > t[0] && r[1] < t[3])) {
            e.label = r[1];
            break;
          }
          if (r[0] === 6 && e.label < t[1]) {
            e.label = t[1], t = r;
            break;
          }
          if (t && e.label < t[2]) {
            e.label = t[2], e.ops.push(r);
            break;
          }
          t[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      r = o.call(i, e);
    } catch (c) {
      r = [6, c], a = 0;
    } finally {
      n = t = 0;
    }
    if (r[0] & 5) throw r[1];
    return { value: r[0] ? r[1] : void 0, done: !0 };
  }
}
function x(i, o, e) {
  if (e || arguments.length === 2) for (var n = 0, a = o.length, t; n < a; n++)
    (t || !(n in o)) && (t || (t = Array.prototype.slice.call(o, 0, n)), t[n] = o[n]);
  return i.concat(t || Array.prototype.slice.call(o));
}
var v = "templates", A = function(i, o, e) {
  return p(i)(l({ system_name: e || v }, o || {}));
}, I = function(i, o) {
  var e = l(l({}, o), { interaction_name: i });
  return p(h)(e);
};
function p(i) {
  var o = b();
  return o.emitFunction = m, function(n) {
    return _(this, void 0, void 0, function() {
      var a;
      return w(this, function(t) {
        return a = l({ system_name: v }, n), d(
          "event",
          // @ts-expect-error // interaction_name might not exist on data
          a.interaction_name || i,
          a
        ), o.emit(a, i), [
          2
          /*return*/
        ];
      });
    });
  };
}
export {
  l as _,
  j as a,
  x as b,
  A as c,
  I as e
};
//# sourceMappingURL=emitEvent-B5xAYp5K.mjs.map
